export const supervisorState = (state = {}, action) => {
  if (action.type === 'UPDATE_SUPERVISOR') {
    const newState = { ...state, ...action.supervisorState };

    return newState;
  }

  return state;
};
